import React, { Component } from "react";
import { ArrowUp } from "lucide-react";
import "./scrollToTop.css";

class GoTop extends Component {
  state = { visible: false };

  componentDidMount() {
    document.addEventListener("scroll", () => {
      this.setState({ visible: window.scrollY > 200 });
    });
  }

  render() {
    if (!this.state.visible) return null;
    return (
      <a href="#top" className="go-up" aria-label="Idi na vrh stranice">
        <ArrowUp size={18} strokeWidth={2.2} />
      </a>
    );
  }
}

export default GoTop;
